import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SigninComponent } from "../auth/signin/signin.component";
const appRoutes: Routes =
[{ path: '', component: SigninComponent, pathMatch: 'full'},];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)
          ],
  exports: [RouterModule]
})
export class CoreRoutingModule {
}
